<div class="content mt-2 mb-3">
  <app-datatable
    [dataSource]="deviceSource"
    [columns]="columns"
    [compactPortraitColumnCount]="2"
    [compactPortraitColumns]="compactPortraitColumns"
    [identifier]="'scanner'"
    [actionNew]="false"
    (showEvent)="show($event.valueOf())"
  >
    <app-empty-table
      [icon]="'devices'"
      [emptyText]="'mdm.empty_text' | translate"
      [buttonText]="'worker.pair' | translate"
      (btnClick)="emptyButtonClick()"
    >
    </app-empty-table>
  </app-datatable>
</div>
